import React, { useEffect } from "react";
import Layout from "../../components/common/Layout";
import LoginComponent from "../../components/common/user/LoginComponent";
import { Container, useMediaQuery, useTheme } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanelComponent from "../../components/common/TabPanelComponent";
import { getTitle, searchParamToObject } from "../../helpers/SearchParamHelper";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EdiComponent from "../../components/common/edi/EdiComponent";
import EnteringInvoiceComponent from "../../components/common/edi/EnteringInvoiceComponent";
import Box from "@mui/material/Box";
import ReapproComponent from "../../components/common/edi/reappro/ReapproComponent";
import ConsoleAchatComponent from "../../components/common/edi/reappro/ConsoleAchatComponent";
import OpenAiComponent from "../../components/common/edi/OpenAiComponent";
import GroupagesComponent from "../../components/common/edi/groupage/GroupagesComponent";

const EdiScreen: React.FC = React.memo(() => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
  const getValue = React.useCallback(() => {
    const searchParamsObject = searchParamToObject(searchParams);
    return searchParamsObject.tab ? Number(searchParamsObject.tab) : 0;
  }, [searchParams]);
  const [value, setValue] = React.useState(getValue());
  const handleChange = React.useCallback(
    (event: React.SyntheticEvent, newValue: number) => {
      // @ts-ignore
      setSearchParams({
        tab: newValue,
      });
    },
    [setSearchParams]
  );

  useEffect(() => {
    document.title = getTitle("edi");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setValue(getValue());
  }, [searchParams]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Layout>
      <LoginComponent redirect={null} requireAdmin={true}>
        <Tabs
          value={value}
          onChange={handleChange}
          scrollButtons="auto"
          variant={!isSmall ? "standard" : "scrollable"}
          centered={!isSmall}
        >
          <Tab label={t("word.edi")} />
          <Tab label={t("word.openAi")} />
          <Tab label={t("word.enteringInvoices")} />
          <Tab label={t("word.replenishment")} />
          <Tab label={t("word.groupage")} />
          <Tab label={t("word.documentAchat")} />
        </Tabs>
        <TabPanelComponent
          sx={{ marginTop: 1 }}
          value={value}
          index={0}
          removeComponentOnHidden={true}
        >
          <Container maxWidth="xl">
            <EdiComponent />
          </Container>
        </TabPanelComponent>
        <TabPanelComponent
          sx={{ marginTop: 1 }}
          value={value}
          index={1}
          removeComponentOnHidden={true}
        >
          <Container maxWidth="xl">
            <OpenAiComponent />
          </Container>
        </TabPanelComponent>
        <TabPanelComponent
          sx={{ marginTop: 1 }}
          value={value}
          index={2}
          removeComponentOnHidden={true}
        >
          <Container maxWidth="xl" sx={{ paddingY: 2 }}>
            <EnteringInvoiceComponent />
          </Container>
        </TabPanelComponent>
        <TabPanelComponent
          sx={{ marginTop: 1 }}
          value={value}
          index={3}
          removeComponentOnHidden={true}
        >
          <Box sx={{ paddingY: 2 }}>
            <ReapproComponent />
          </Box>
        </TabPanelComponent>
        <TabPanelComponent
          sx={{ marginTop: 1 }}
          value={value}
          index={4}
          removeComponentOnHidden={true}
        >
          <Box sx={{ paddingY: 2 }}>
            <GroupagesComponent />
          </Box>
        </TabPanelComponent>
        <TabPanelComponent
          sx={{ marginTop: 1 }}
          value={value}
          index={5}
          removeComponentOnHidden={true}
        >
          <Box sx={{ paddingY: 2 }}>
            <ConsoleAchatComponent />
          </Box>
        </TabPanelComponent>
      </LoginComponent>
    </Layout>
  );
});

export default EdiScreen;
